import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { UsageCalculator } from '../usage-calculator';
import type { CreditData, CreditUsageKey } from '../../types';

/**
 * 用量计算器实现
 * 提供纯函数式的用量计算能力
 */
@injectable()
export class UsageCalculatorImpl implements UsageCalculator {
    /**
     * 计算多个用量类型的总剩余量
     * @param creditData - 信用数据
     * @param usageKeys - 用量类型的 key 数组
     * @returns 总剩余量（total - usage 之和）
     */
    calculateTotalRemaining(creditData: CreditData, usageKeys: CreditUsageKey[]): number {
        let totalRemaining = 0;

        for (const key of usageKeys) {
            const usage = creditData.usages.get(key);
            if (usage) {
                // total 为 -1 时视为 0（表示无限制或不可用）
                const total = usage.total === -1 ? 0 : usage.total;
                totalRemaining += (total - usage.usage);
            }
        }

        return totalRemaining;
    }
}
